<div class="ws-popup-header">
    <span>{{ title }}</span>
    <div class="actions">
        <button (click)="closeClicked()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<div class="ws-popup-content">
    <div class="qr-content flex column align-center">
        <p class="center gray">{{ 'Show this QR Code' | translate }}</p>

        <canvas #qrCode></canvas>

        <p class="center gray" *ngIf="!!phone || !!email">{{ 'Or share the link' | translate }}</p>

        <div *ngIf="!!phone || !!email" class="share-buttons">
            <ws-button
                    (click)="sendWhatsApp()"
                    *ngIf="!!phone"
                    [callToActionType]="'primary'"
            >
                <img
                        alt="WhatsApp_logo"
                        class="whatsappLogo"
                        src="/assets/images/WhatsApp_logo.png"
                />
                <span class="buttonText">{{ "WhatsApp" | translate }}</span>
            </ws-button>

            <ws-button
                    (click)="sendMailTo()"
                    *ngIf="!!email"
                    [callToActionType]="'secondary'"
            >
                <mat-icon>email</mat-icon>
                <span class="buttonText">{{ "Email" | translate }}</span>
            </ws-button>
        </div>
    </div>
</div>